import { render } from "./notice-icon.vue?vue&type=template&id=0f6ec884&ts=true"
import script from "./notice-icon.vue?vue&type=script&lang=ts"
export * from "./notice-icon.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__